import axios from "axios";
import md5 from 'md5';



const API_URL = 'https://jecs.bacet.org/jecs-lumen-api/family-tree-app/lumen/public/v1';
const SALT = 'ERIK!@!$$$!@!2024';


// Function to generate an auth_token by hashing the email + SALT
const generateAuthToken = (input) => {
    return md5(`${SALT}${input}`);
    
}


// Login API
export const loginUser = async (email, password) => {
    try {
        // Generate auth_token
        const auth_token = generateAuthToken(email);
    
        // Make the login request
        const response = await axios.post(`${API_URL}/auth_login`, { 
            auth_token,
            email, 
            password 
        });

        return response.data;
    } catch (error) {
        throw(error);
    }
};

// API's Call
export const authApi = async(input_token, data, apiUrl, token) => {
    const auth_token = {"auth_token": generateAuthToken(input_token)};
    const mergedObject = { ...data, ...auth_token };
    
    try {
        const response = await axios.post(
            `${API_URL}/${apiUrl}`,
            mergedObject,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json' // Set content type to JSON
                }
            }
        );
        return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
}

export const formauthApi = async (input_token, formDataToSend, apiUrl, token) => {
    // Generate the auth token and append it directly to FormData
    const auth_token = generateAuthToken(input_token);
    formDataToSend.append('auth_token', auth_token);

    try {
        // Make the API call with FormData
        const response = await axios.post(
            `${API_URL}/${apiUrl}`,
            formDataToSend, // Pass the FormData object directly
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data', // Ensure multipart/form-data
                },
            }
        );

        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error; // Rethrow for handling outside
    }
};


